import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByCompany() {
  return (
    <ScansGroupedReport
      title="Scan by Company"
      subtitle="Scans grouped by the company linked to the scanned QR / fuel access's retail outlet."
      dimension="company"
      dropdownLabel="Company"
      dropdownPlaceholder="All companies"
      dropdownApiPath="/master/companies"
    />
  );
}
